export default __webpack_public_path__ + "static/Lena-5eb09d0c575a49bd2bffadba5a0e216c.png";